import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AnimationReunion, AnimationReunionAll } from '@app/models/animationReunion';
import { ContratAccueilMentalo, EnfantMentalo } from '@app/models/contrat-accueil';
import { ConfigMentalo } from '@app/models/mentalo';
import { BaseConfigService, PlatformService, SnackbarService, UserService } from '@app/services';
import { AssmatService } from '@app/services/assmat.service';
import moment from 'moment';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-inscription-animations',
  templateUrl: './inscription-animations.component.html',
  styleUrls: ['./inscription-animations.component.scss'],
  standalone: false
})
export class InscriptionAnimationsComponent implements OnInit {

  idAssmat: number;
  listContrats: ContratAccueilMentalo[];
  listChild: EnfantMentalo[];
  listAnimations: AnimationReunion[];
  listAnimationsFiltered: AnimationReunion[];
  // listChildWithContratEnabled: EnfantMentalo[];
  saving = false;
  drawerOpened = false;
  canRegister: boolean;
  RegisterChildDialogRef: MatDialogRef<any>;
  registerChildList: number[];
  filters = {
    search: "",
    etablissement: 0,
    fromDate: "",
    toDate: ""
  };

  @ViewChild('RegisterChildDialog', { static: true }) RegisterChildDialog: TemplateRef<any>;

  constructor(
    private assmatService: AssmatService,
    private userService: UserService,
    private matDialog: MatDialog,
    private platformService: PlatformService,
    private snackbar: SnackbarService,
    private configService: BaseConfigService
  ) { }

  ngOnInit(): void {
    this.idAssmat = this.userService.currentUser.idAssmat || null;
    this.loadAnimations();
  }

  loadAnimations() {
    forkJoin([
      this.assmatService.getAnimationsByIdAssmat(this.idAssmat),
      this.assmatService.getEnfantsMentaloByIdAssMat(this.idAssmat),
      this.assmatService.getContratsAccueilByIdAssMat(this.idAssmat),
      this.configService.get('mentalo')
    ]).subscribe(([listAnim, childList, contrats, config]: [AnimationReunionAll, EnfantMentalo[], ContratAccueilMentalo[], ConfigMentalo]) => {
      this.listContrats = contrats;
      this.listChild = childList;
      this.listAnimations = this.assmatService.filtrerAnimationsReunionAvailables(listAnim.tabAvailable);
      this.listAnimations = this.assmatService.sortByDate(this.listAnimations);
      this.listAnimationsFiltered = this.listAnimations;
      this.canRegister = this.assmatService.canRegisterMore(listAnim.tabInscriptions, 'animation', config)
    })
  }

  openRegisterChildDialog(animation) {
    let listChild = this.assmatService.getChildListWithContratEnable(this.listContrats, this.listChild, animation.date);
    this.RegisterChildDialogRef = this.matDialog.open(this.RegisterChildDialog, {
      data: { listChild, animation },
      maxWidth: '700px',
      minWidth: 'min(500px, 100%)'
    });

    this.platformService.adaptDialogToScreen(this.RegisterChildDialogRef);

    this.RegisterChildDialogRef.afterClosed().subscribe(_ => {
      this.registerChildList = [];
    });
  }

  clickToConfirm(animationReunion: AnimationReunion) {

    let animationReunionPortail = {
      idAnimation: animationReunion.idAnimation,
      idAssmat: this.idAssmat,
    }

    this.saving = true;
    this.assmatService.inscriptionAnimationReunion(
      this.idAssmat, {
      idPortailAnimationReunionAssmat: animationReunion.portailInscription?.idPortailAnimationReunionAssmat,
      selectedChild: this.registerChildList,
      animationReunionPortail
    }).subscribe(_ => {
      animationReunion.saving = true;
      this.loadAnimations();
      this.RegisterChildDialogRef.close();
      this.registerChildList = [];
      this.saving = false;
      this.snackbar.info('Inscription Réussie');
    }, err => this.snackbar.error('Erreur lors de l\'inscription'))
  }

  cancel() {
    this.RegisterChildDialogRef.close();
    this.registerChildList = [];
  }

  closeDrawer() {
    this.drawerOpened = false;
  }

  toggleAnimationsOptions() {
    this.drawerOpened = !this.drawerOpened;
  }

  changeFilter(event) {
    if (event) {
      this.listAnimationsFiltered = this.listAnimations.filter(animation => {
        return (animation.titre.toLowerCase().includes(this.filters.search.toLowerCase()) || this.filters.search === '') &&
          (moment(animation.date).isSameOrAfter(this.filters.fromDate, 'day') || !moment(this.filters.fromDate).isValid()) &&
          (moment(animation.date).isSameOrBefore(this.filters.toDate, 'day') || !moment(this.filters.toDate).isValid());
      })
    }
  }

}
